import images from './images';

const wines = [
  {
    title: 'Baby Potatoes',
    price: 'R25 | R35',
    tags: '500G | 1KG',
  },
  {
    title: 'Butternut',
    price: 'R20 | R30',
    tags: '500G | 1KG',
  },
  {
    title: 'Beetroot',
    price: 'R30 | R50',
    tags: '500G | 1KG',
  },
  {
    title: 'Baby Marrow',
    price: 'R35 | R65',
    tags: '500G | 1KG',
  },
  {
    title: 'Cabbage Shredded',
    price: 'R20 | R30',
    tags: '500G | 1KG',
  },
];

const cocktails = [
  {
    title: 'Coselaw Mix',
    price: 'R25 | R35',
    tags: '500G | 1KG',
  },
  {
    title: "Country Fresh Mix",
    price: 'R25 | R50',
    tags: '500G | 1KG',
  },
  {
    title: 'Carrots',
    price: 'R25 | R35',
    tags: '500G | 1KG',
  },
  {
    title: 'Green Beans cut and Julienne Carrot Mix ',
    price: 'R30 | R40',
    tags: '500G | 1KG',
  },
  {
    title: 'Mixed bell peppers',
    price: 'R50 | R85',
    tags: '500G | 1KG',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Bib Gourmond',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { wines, cocktails, awards };
